import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Logo } from "../Icons";

export function NotSubscribed({ text }) {
  const navigate = useNavigate();
  return (
    <>
      <div className="vh-100 vw-100 d-flex align-items-center justify-content-center text-center">
        <div>
          <Logo />
          <h4 className="display-5"> Unauthorized </h4>{" "}
          <Button
            onClick={() => navigate(-1)}
            variant=""
            className="text-primary text-underline"
          >
            Go back
          </Button>
        </div>
      </div>
    </>
  );
}
